export default function (identifier) {
    sessionStorage.removeItem(identifier)
}
